const dateFormat = 'MMM DD, YYYY';
const ddmmmmyyyy = 'DD MMMM YYYY';
const yyyymmddhhmmss = 'YYYY-MM-DD HH:mm:ss';
const success = 'success';
const error = 'error';
const info = 'info';
const warning = 'warning';
const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType = 'application/wps-office.xlsx';
const OtherXlsx =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const JsonType = 'application/json';
const JsType = 'text/javascript';
const pythonDjangoType = 'text/x-python';
const DmnType = 'dmn';
const dateFormatWithHyphen = 'YYYY-MM-DD';
const ddmmyyWithHyphen = 'DD-MM-YYYY';
const defaultTemplateTypes = [
  'reminder',
  'escalation',
  'auto_approval',
  'after_task_approval',
];
const approved = 'APPROVED';

const constants = {
  dateFormat,
  ddmmmmyyyy,
  yyyymmddhhmmss,
  success,
  error,
  info,
  warning,
  XlsType,
  XlsWpsType,
  XlsxType,
  CsvType,
  JsonType,
  JsType,
  pythonDjangoType,
  DmnType,
  OtherXlsx,
  dateFormatWithHyphen,
  ddmmyyWithHyphen,
  defaultTemplateTypes,
  approved,
};

export default constants;
